var map = {
	"./address.js": "60122",
	"./admittance.js": "0261",
	"./bidmanagementpur.js": "c578",
	"./bill.js": "5d2b",
	"./codingrules.js": "a3def",
	"./contract.js": "53f5",
	"./data.js": "8682",
	"./delivery-purchase.js": "ec4e",
	"./deliveryappointment.js": "eb9d",
	"./deliverypurchase.js": "653c",
	"./deliverysynergy.js": "5e6b",
	"./goods.js": "328c",
	"./inquiry.js": "891d",
	"./inventory-collaboration.js": "f1d3",
	"./materiel.js": "66c9",
	"./orderdelivery.js": "0879",
	"./orderpurchase.js": "2fc9",
	"./performance.js": "0412",
	"./performanceAppraisal.js": "c83b",
	"./purbill.js": "36e5",
	"./purdataanalysis.js": "cf9e",
	"./qualitycollaboration.js": "8bf8",
	"./relation.js": "79ab",
	"./release-manage.js": "97ca",
	"./signature-manage.js": "e574",
	"./statementofaccount.js": "4b02",
	"./supplier-develop.js": "0462",
	"./supplier.js": "c507"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49cd";